import * as React from 'react'
import Button from '@doordash/component-button'
import { clone, setWith } from 'lodash'
import { OnboardingComponentProps } from '.'

export const RouteButtonComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({
    templateResponseData,
    onSubmitStep,
    apiPath,
    ...props
  }: OnboardingComponentProps) => {
    const handleButtonClick = () => {
      const isComplete = true

      const updatedTemplateResponseData = setWith(
        clone(templateResponseData),
        apiPath,
        isComplete,
        clone
      )
      onSubmitStep(updatedTemplateResponseData)
    }

    return <Button onClick={handleButtonClick} {...props} />
  }
)
